// extracted by mini-css-extract-plugin
export var link = "_vk-0";